import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useQuery } from '@apollo/react-hooks';
import {
  UiSettingsFieldOptionsQuery,
  UiSettingsFieldOptionsQueryVariables
} from './__generated__/UiSettingsFieldOptionsQuery';

const UI_SETTINGS_FIELD_OPTIONS_QUERY = gql`
  query UiSettingsFieldOptionsQuery($campaignId: ID) {
    uiSettingsFieldOptions(campaignId: $campaignId) {
      facebookConversionFields
      keyweeConversionFields
      dailyGraphFields
      reportBreakdownOptions
      externalConversionFields
    }
  }
`;

export const useUiSettingsFieldOptionsQuery = (variables: UiSettingsFieldOptionsQueryVariables) => {
  return useQuery<UiSettingsFieldOptionsQuery, UiSettingsFieldOptionsQueryVariables>(UI_SETTINGS_FIELD_OPTIONS_QUERY, {
    client: kmsClient,
    variables
  });
};
